export default __webpack_public_path__ + "static/media/first-overlap-class.0912bc00.png";